import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EmployeeService {
  constructor(private http: HttpClient) {}

  getEmployees(data, commonData): Observable<any[]> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/get_employee_det?limit=${commonData.limit}&page=${commonData.page}`,
      { params: param }
    );
  }
  getEmployeesProfile(empId): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/get_emp_profile/` + empId
    );
  }
  
  getLoggedInEmpDetails(): Observable<any> {
    return this.http.get<any[]>(`${environment.apiUrl}/loggedin_emp_detail`);
  }

  getEmployeesDetails(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/get_emp_details`,
      req
    );
  }
  changeExitRsn(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/change_exit_reason`,
      req
    );
  }

  getEmpMarrital(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/employee_select_status`
    );
  }
  getEmpGender(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/employee_select_gender`
    );
  }
  getEmpBlood(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/employee_select_blood_group`
    );
  }
  addEmpDet(req): Observable<any[]> {
    if (req.det_id === '') {
      // return this.http.post<any[]>(`${environment.apiUrl}/employee/add_emp_family_details`, req);
    }
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/edit_employee_det_action`,
      req
    );
  }
  addEmpDetBasic(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/edit_employee_det_basic_action`,
      req
    );
  }
  editEmpDet(detId): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/edit_employee_det/` + detId
    );
  }
  getEmpDetail(emID): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/get_emp_basic_det/` + emID
    );
  }

  getEmpExitDetail(emID): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/get_emp_exit_det/` + emID
    );
  }

  genEmpExpLetter(params): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/gen_exp_letter`,
      params
    );
  }

  getEmpRelation(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/get_relationship`
    );
  }
  getEmpRelationMed(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/get_relationship_med`
    );
  }
  addEmpFam(req): Observable<any[]> {
    if (
      req.family_id === '' ||
      req.family_id == null ||
      req.family_id === undefined
    ) {
      return this.http.post<any[]>(
        `${environment.apiUrl}/employee/add_emp_family_details`,
        req
      );
    }
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/edit_emp_family_details_action`,
      req
    );
  }
  deleteEmpFam(famId): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/delete_emp_family_details`,
      { dpndt_id: famId }
    );
  }
  editEmpFam(famId): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/edit_emp_family_detail/` + famId
    );
  }
  getEmpFam(id): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/get_emp_family_details/` + id
    );
  }
  getEmpFamMediclaim(id): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/get_emp_family_details_mediclaim/` + id
    );
  }

  getEmpEduOption(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/employee/get_education`);
  }
  getEmpEducation(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/get_emp_education`
    );
  }
  addEmpEdu(req): Observable<any[]> {
    if (req.edu_id === '' || req.edu_id == null || req.edu_id === undefined) {
      return this.http.post<any[]>(
        `${environment.apiUrl}/employee/add_emp_education_details`,
        req
      );
    }
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/edit_emp_education_action`,
      req
    );
  }
  // deleteEmpEdu(famId): Observable<any[]> {
  //   return this.http.delete<any[]>(`${environment.apiUrl}/employee/delete_emp_family_details/` + famId);
  // }
  editEmpEdu(eduId): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/edit_emp_education/` + eduId
    );
  }
  getEmpEdu(id): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/get_emp_education/` + id
    );
  }

  getEmpExpOption(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/get_experience`
    );
  }
  // getEmpExperience(): Observable<any[]> {
  //   return this.http.get<any[]>(`${environment.apiUrl}/employee/get_emp_experience_details`);
  // }
  addEmpExp(req): Observable<any[]> {
    if (req.exp_id === '' || req.exp_id == null || req.exp_id === undefined) {
      return this.http.post<any[]>(
        `${environment.apiUrl}/employee/add_emp_experience_details`,
        req
      );
    }
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/edit_experience_action`,
      req
    );
  }
  // deleteEmpExp(expId): Observable<any[]> {
  //   return this.http.delete<any[]>(`${environment.apiUrl}/employee/delete_emp_family_details/` + expId);
  // }
  editEmpExp(expId): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/edit_experience/` + expId
    );
  }
  getEmpExp(id): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/get_emp_experience_details/` + id
    );
  }

  getEmpExpDesc(ID): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_options_mod/` + ID);
  }

  getEmpIdCard(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/get_emp_idcard`
    );
  }

  upEmpIDCard(req): Observable<any[]> {
    if (req.req_id_img === '') {
    }
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/update_emp_idcard`,
      req
    );
  }

  upEmpImage(req): Observable<any[]> {
    if (req.emp_id === '') {
    }
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/update_emp_image`,
      req
    );
  }
  editEmpImge(ID): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/edit_emp_img/` + ID
    );
  }

  editEmpIdCard(ID): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/edit_emp_idcard/` + ID
    );
  }

  downloadZip(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/download_zip`,
      req
    );
  }

  getEmpPayroll(ID): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/view_emp_payroll/` + ID
    );
  }
  getGroupOptions(ID): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_options/` + ID);
  }
  getDesignation(req = ''): Observable<any[]> {
    if (req != '') {
      return this.http.get<any[]>(
        `${environment.apiUrl}/get_designation?excel=1`
      );
    } else {
      return this.http.get<any[]>(`${environment.apiUrl}/get_designation`);
    }
  }
  getLevel(req = ''): Observable<any[]> {
    if (req != '') {
      return this.http.get<any[]>(
        `${environment.apiUrl}/get_level?excel=1`
      );
    } else {
      return this.http.get<any[]>(`${environment.apiUrl}/get_level`);
    }
  }
  getDepartment(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_departments`);
  }
  getSubDepartment(ID): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/get_sub_departments/` + ID
    );
  }
  getSegment(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/select_segment`);
  }

  getRegion(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/select_region`);
  }
  getEmpCCHistory(empID): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/employee_cc_history/` + empID
    );
  }
  getEmpJoiningHistory(empID): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/get_emp_joining_history/` + empID
    );
  }

  getExitEmployee(data): Observable<any[]> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/employee/get_exit_employee`,
      { params: param }
    );
  }
  getMirgantLocalite(ID): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_options_mod/` + ID);
  }
  getExtendDateRule(ID): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_app_rule/` + ID);
  }
  approveFnfExcel(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/appr_employee_fnf_excel`,
      req
    );
  }
  getExitFNF(data): Observable<any[]> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(`${environment.apiUrl}/employee/get_fnf_exit`, {
      params: param,
    });
  }
  rejectEmployeeFNF(params): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/reject_employee_fnf`,
      params
    );
  }
  bulkRejectEmployeeFNF(params): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/reject_bulk_employee_fnf`,
      params
    );
  }

  getFNFReworking(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/get_fnf_reworking`
    );
  }
  getFNFIgnore(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/get_fnf_ignore`
    );
  }
  getFNFLeave(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/employee/get_fnf_leave`);
  }
  getFNFOvertime(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/get_fnf_overtime`
    );
  }
  getFNFEarning(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/get_fnf_earning`
    );
  }
  getFNFDeduction(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/get_fnf_deduction`
    );
  }
  getFNFAttendance(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/get_fnf_attendance`
    );
  }
  getFNFMasterChanges(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/get_fnf_master_changes`
    );
  }
  finishOffboradChklist(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/check_emp_offborad_checklist`,
      req
    );
  }
  freezeFamily(data): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/freeze_family_action`,
      data
    );
  }
  getExitBlacklistedEmp(data): Observable<any[]> {
    let param = new HttpParams();
    for (const key in data.forms) {
      if (
        data.forms !== '' &&
        data.forms !== undefined &&
        data.forms !== null
      ) {
        param = param.append(key, data.forms[key]);
      }
    }
    if (
      'pageIndex' in data &&
      data.pageIndex !== '' &&
      data.pageIndex !== undefined
    ) {
      param = param.append('page', data.pageIndex);
    }
    if ('limit' in data && data.limit !== '' && data.limit !== undefined) {
      param = param.append('limit', data.limit);
    }
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/get_blacklisted_employee`,
      { params: param }
    );
  }
  removeEmployeeFromBalcklist(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/remove_employee_blacklist`,
      req
    );
  }

  // exit tasks
  exitTaskSubmit(req): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/add_task_transfer_action`,
      req
    );
  }
  getEmpUpdationHistory(empID): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/get_emp_updation_history/` + empID
    );
  }

  getBankMaster(data): Observable<any> {
    // let param = new HttpParams();
    // for (const key in data) {
    //   if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
    //     param = param.append(key, data[key]);
    //   }
    // }
    return this.http.post<any>(
      `${environment.apiUrl}/mis-reports/get_bnk_detail_reports`,
      data
    );
  }
  getEmpDesig(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/mis-reports/get_emp_desig`,
      { params: param }
    );
  }

  deleteBankAccount(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/mis-reports/deleteBankAccount`,
      data
    );
  }

  inActiveBankAccount(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/mis-reports/inactive_bank_account`,
      data
    );
  }

  userEventCheck(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/renew/user_can_renew_upload`
    );
  }
  getRenewalLetterTemplate(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/renew/get_renewal_template`
    );
  }
  uploadRenewalLetter(data): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/renew/upload_renewal_letter`,
      data
    );
  }
  getRenewEmployeeData(data): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/renew/get_renewal_employees`,
      data
    );
  }
  generateRenewalLetter(data): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/renew/generate_renewal_letter`,
      data
    );
  }
  generateSingleRenewalLetter(data): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/renew/generate_single_renewal_letter`,
      data
    );
  }
  getRenewalHistory(empID): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/renew/get_emp_renewal_history/` + empID
    );
  }
  rejectRenewalLetter(data): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/renew/reject_renewal_letter`,
      data
    );
  }

  userTypeGet(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/select_user_type`);
  }

  addUser(data, edit_user_id): Observable<any> {
    if (
      edit_user_id == '' ||
      edit_user_id == null ||
      edit_user_id == undefined
    ) {
      return this.http.post<any>(
        `${environment.apiUrl}/employee/users/add_user_action`,
        data
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/employee/users/edit_user_action`,
        data
      );
    }
  }

  getExternalUser(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get(
      `${environment.apiUrl}/employee/users/get_external_user`,
      { params: param }
    );
  }

  getNapsUser(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get(`${environment.apiUrl}/employee/users/get_naps_user`, {
      params: param,
    });
  }

  editUsers(userId): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/employee/users/edit_user/` + userId
    );
  }

  // start ER service

  addEmployeePmYojana(req, map_id): Observable<any[]> {
    if (map_id == '' || map_id == null || map_id == undefined) {
      return this.http.post<any[]>(
        `${environment.apiUrl}/employee/er-emp/add_emp_pmyojana_action`,
        req
      );
    }
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/er-emp/edit_emp_pmyojana_action`,
      req
    );
  }
  getEmployeePMYojana(uid): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/er-emp/get_emp_pmyojana/` + uid
    );
  }
  editYojana(id): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/er-emp/edit_emp_pmyojana/` + id
    );
  }
  //
  addEmployeeCourse(req, map_id): Observable<any[]> {
    if (map_id == '' || map_id == null || map_id == undefined) {
      return this.http.post<any[]>(
        `${environment.apiUrl}/employee/er-emp/add_emp_course_action`,
        req
      );
    }
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/er-emp/edit_emp_course_action`,
      req
    );
  }
  getEmployeeCourse(uid): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/er-emp/get_emp_course/` + uid
    );
  }
  deleteEmpCourse(id): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/er-emp/delete_course`,
      { map_id: id }
    );
  }
  editEmpCourse(id): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/er-emp/edit_emp_course/` + id
    );
  }

  addEmployeeMedical(req, map_id): Observable<any[]> {
    if (map_id == '' || map_id == null || map_id == undefined) {
      return this.http.post<any[]>(
        `${environment.apiUrl}/employee/er-emp/add_emp_medical_action`,
        req
      );
    }
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/er-emp/edit_emp_medical_action`,
      req
    );
  }
  getEmployeeMedical(id): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/er-emp/get_emp_medical/` + id
    );
  }
  editEmpMedical(id): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/er-emp/edit_emp_medical/` + id
    );
  }
  deleteEmpMedical(id): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/er-emp/delete_medical`,
      { map_id: id }
    );
  }

  addEmployeePassport(req, psprt_id): Observable<any[]> {
    if (psprt_id == '' || psprt_id == null || psprt_id == undefined) {
      return this.http.post<any[]>(
        `${environment.apiUrl}/employee/er-emp/add_emp_passport_action`,
        req
      );
    }
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/er-emp/edit_emp_passport_action`,
      req
    );
  }

  getEmployeePassport(id): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/er-emp/get_emp_passport/` + id
    );
  }

  editEmpPassport(id): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/er-emp/edit_emp_passport/` + id
    );
  }

  addEmployeeVisa(req, visa_id): Observable<any[]> {
    if (visa_id == '' || visa_id == null || visa_id == undefined) {
      return this.http.post<any[]>(
        `${environment.apiUrl}/employee/er-emp/add_emp_visa_action`,
        req
      );
    }
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/er-emp/edit_emp_visa_action`,
      req
    );
  }
  getEmployeeVisa(id): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/er-emp/get_emp_visa/` + id
    );
  }
  editEmpVisa(id): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/er-emp/edit_emp_visa/` + id
    );
  }
  deleteEmpVisa(id): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/er-emp/delete_visa`,
      { visa_id: id }
    );
  }
  getEmployeePccDetails(id): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/er-emp/get_emp_pcc_details/` + id
    );
  }

  getempUniformDetails(id): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/er-emp/get_emp_uniform_details/` + id
    );
  }

  getempShoesDetails(id): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/er-emp/get_emp_shoes_details/` + id
    );
  }

  getempVaccStatus(id): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/er-emp/get_emp_vaccination_status/` + id
    );
  }

  addEmployeeCDC(req, psprt_id): Observable<any[]> {
    if (psprt_id == '' || psprt_id == null || psprt_id == undefined) {
      return this.http.post<any[]>(
        `${environment.apiUrl}/employee/er-emp/add_emp_cdc_action`,
        req
      );
    }
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/er-emp/edit_emp_cdc_action`,
      req
    );
  }

  getEmployeeCDC(id): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/er-emp/get_emp_cdc/` + id
    );
  }

  editEmpCDC(id): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/er-emp/edit_emp_cdc/` + id
    );
  }

  deleteEmpCDC(id): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/er-emp/delete_cdc`,
      { cdc_id: id }
    );
  }

  // end er serice

  // assesment

  getEmployeeAssesment(id): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/employee/get_emp_assesment/` + id);
  }
  editEmployeeAssesment(id): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/employee/edit_emp_assesment/` + id);
  }
  addEmployeeAssesment(req): Observable<any[]> {
      return this.http.post<any[]>(`${environment.apiUrl}/employee/add_emp_assesment_action`,req);
  }
  
  getEmpVisitingCard(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/get_emp_visiting_card`
    );
  }

  updateBulkDesigEmp(req): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/update_emp_desig_bulk`,
      req
    );
  }

////////////user option services////////////////////////////////////
UserOptionList(data:any): Observable<any[]> {
  return this.http.post<any[]>(
    `${environment.apiUrl}/employee/list_user_option`
  ,data);
}
SearchUserOption(req:any): Observable<any> {
  return this.http.post<any[]>(
    `${environment.apiUrl}/employee/search_User_Types`,
    req
  );
}
AddUserOption(req:any): Observable<any> {
  return this.http.post<any[]>(
    `${environment.apiUrl}/employee/add_user_option`,
    req
  );
}

changeUserOptionStatus(useroptid:any, stat:any): Observable<any[]> {
  const option = {
    status: stat,
    useroptid : useroptid
  };
  const options = new HttpParams({ fromObject: option });
  return this.http.post<any>(`${environment.apiUrl}/employee/status_update_user_option`, options);
}

getUserOptionDetails(id:any): Observable<any[]> {
 
  return this.http.get<any>(`${environment.apiUrl}/employee/get_useropt_details/`+id);
}

editUserOption(data:any): Observable<any[]> {
 
  return this.http.post<any>(`${environment.apiUrl}/employee/editUserOption`,data);
}

  getEmployeeForRetentionApproval(data, commonData): Observable<any[]>{
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(`${environment.apiUrl}/employee/get_retention_approvals`,
    { params: param });
  }

  
  updateRejectionRemark(data:any): Observable<any[]> {
    
    if(data.trans_id && data.trans_id!='')
    {
      return this.http.post<any>(`${environment.apiUrl}/employee/modify_exit_remark`,data);
    }
    else
    {
      return this.http.post<any>(`${environment.apiUrl}/employee/update_exit_remark`,data);
    }
  }
  getExitLevelRemark(id): Observable<any[]>{
    return this.http.get<any>(`${environment.apiUrl}/employee/get_exit_remark_level/` + id);
  }

  updateExitLevelRemark(id): Observable<any[]>{
    return this.http.get<any>(`${environment.apiUrl}/employee/update_exit_remark_level/` + id);
  }

  approveRejectExit(id,status): Observable<any[]>{
    return this.http.get<any>(`${environment.apiUrl}/employee/approve_reject_exit/` + id + "/"+status);
  }
  
}
